import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { message, Table, Card, Typography } from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import VisitCntPacketItem from "./visit-cnt-packet-item";
import { isMobile } from "@extensions/design";
const { Text } = Typography;

const VisitCntPacket = ({ clientId, onRefresh, visitId, finish }) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState();

  const getData = () => {
    setLoading(true);
    serverFetch(`sale/ProductListClient/${clientId}`)
      .then(data => {
        setLoading(false);
        setItems(data);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, [clientId]);

  const columns = [
    Table.SELECTION_COLUMN,
    { dataIndex: "saleId", title: "#"},
    { title: "Услуга", render: record => <div>{record.productName} / {record.mainProductName}</div> },
    { dataIndex: "qty", title: "Продано", align: "right" },
    { dataIndex: "qtyRest", title: "Остаток", align: "right" },
    Table.EXPAND_COLUMN,
  ]

  const onRowClick = (record) => setSelected(selected === record.id ? null : record.id)

  const onItemClose = (refresh) => {
    setSelected(null);
    refresh && getData();
    refresh && onRefresh();
  }

  return <div>
    {!isMobile ? (<Table dataSource={items} loading={loading} columns={columns} pagination={false} size="small" rowKey="id" 
      expandable={{
        expandedRowRender: (record) => <VisitCntPacketItem onClose={onItemClose} itemMain={record} visitId={visitId} />, expandedRowKeys: [selected],
        onExpand: (expanded, record) => setSelected(expanded ? record.id : null),
        expandIcon: ({ expanded, onExpand, record }) => expanded ? <DownOutlined onClick={(e) => onExpand(record, e)} /> : <RightOutlined onClick={(e) => onExpand(record, e)} />,
        rowExpandable: () => true,
        className: "cl-abons-expandable",
      }}
      onRow={record => ({ onClick: () => onRowClick(record) })}
      rowSelection={{ type: 'radio', selectedRowKeys: [selected], renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
    />) : (
      items.map((item) => {
        const expanded = selected === item.id;
      
        return (
          <Card
            key={item.id}
            size="small"
            style={{
              backgroundColor: "var(--theme-light)",
              marginBottom: 4,
              padding: 8,
              cursor: "pointer",
              borderLeft: `4px solid ${expanded ? "#2f6f00" : "#d9d9d9"}`,
            }}
            onClick={() => setSelected(expanded ? null : item.id)}
          >
            <div className="visit-packet-card-header">
              <div className="visit-packet-card-left">
                <Text strong className="visit-item-clip">
                {item.productName} / {item.mainProductName}
                </Text>
              </div>
            </div>
 
            <div className="visit-packet-card-fields" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Text className="visit-item-clip" style={{ textAlign: 'left' }}>
                Остаток: {item.qtyRest}
              </Text>
              <Text className="visit-item-clip" style={{ textAlign: 'right' }}>
                Всего: {item.qty}
              </Text>
            </div>

            <div
              className="visit-packet-card-expand"
              style={{
                maxHeight: expanded ? 800 : 0,
                opacity: expanded ? 1 : 0,
                overflow: "hidden",
                transition: "max-height 0.3s ease, opacity 0.2s ease",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {expanded && (
                <VisitCntPacketItem
                  onClose={onItemClose}
                  itemMain={item}
                  visitId={visitId}
                  finish={finish}
                />
              )}
            </div>
          </Card>
        );
      })
    )}
  </div>
}

export default VisitCntPacket;
